// deps
import React from "react";

// internal deps
import { CreditCardEMIGroup, ICreditCardEMIGroup } from "@swiggy-private/payment-ui";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// hooks
import { usePaymentActions } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UsePaymentActions";

interface CreditCardEMIGroupHandlerProps extends Omit<PaymentGroupHandlerProps, "paymentGroup"> {
    paymentGroup: ICreditCardEMIGroup["paymentData"];
}

export function CreditCardEMIGroupHandler(props: CreditCardEMIGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const paymentActions = usePaymentActions(props);

    return <CreditCardEMIGroup paymentActions={paymentActions} paymentData={props.paymentGroup} {...otherProps} />;
}
